export default "__VITE_ASSET__zGJ8$Eem__"